"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GameGradeABCEnum = void 0;
var GameGradeABCEnum;
(function (GameGradeABCEnum) {
  GameGradeABCEnum[GameGradeABCEnum["markAplus"] = 0] = "markAplus";
  GameGradeABCEnum[GameGradeABCEnum["markA"] = 1] = "markA";
  GameGradeABCEnum[GameGradeABCEnum["markAminus"] = 2] = "markAminus";
  GameGradeABCEnum[GameGradeABCEnum["markBplus"] = 3] = "markBplus";
  GameGradeABCEnum[GameGradeABCEnum["markB"] = 4] = "markB";
  GameGradeABCEnum[GameGradeABCEnum["markBminus"] = 5] = "markBminus";
  GameGradeABCEnum[GameGradeABCEnum["markCplus"] = 6] = "markCplus";
  GameGradeABCEnum[GameGradeABCEnum["markC"] = 7] = "markC";
  GameGradeABCEnum[GameGradeABCEnum["markCminus"] = 8] = "markCminus";
  GameGradeABCEnum[GameGradeABCEnum["markDplus"] = 9] = "markDplus";
  GameGradeABCEnum[GameGradeABCEnum["markD"] = 10] = "markD";
  GameGradeABCEnum[GameGradeABCEnum["markDminus"] = 11] = "markDminus";
  GameGradeABCEnum[GameGradeABCEnum["markF"] = 12] = "markF";
})(GameGradeABCEnum = exports.GameGradeABCEnum || (exports.GameGradeABCEnum = {}));
